import type { CopyCatalog } from "./copyTypes";

export const NL_COPY: CopyCatalog = {
  "common.loading": "Laden…",
  "common.yes": "Ja",
  "common.no": "Nee",
  "common.notProvided": "Niet opgegeven",
  "common.notRequired": "Niet vereist",
  "common.requested": "Aangevraagd",
  "nav.back": "Terug",
  "nav.continue": "Doorgaan",
  "nav.sendRequest": "Aanvraag versturen",
  "nav.sending": "Versturen…",
  "alert.completeFields": "Vul de gemarkeerde velden in voordat u doorgaat.",
  "fill.filled": "Ingevuld",
  "fill.notFound": "Niet gevonden",
  "fill.shipmentToo": "Zending ook ingevuld: {detail}",
  "fill.palletMany": "pallets",

  "choose.title": "Hoe wilt u uw offerte aanvragen?",
  "choose.manual.title": "Handmatig invullen",
  "choose.manual.description": "Vul uw zending stap voor stap in via het begeleide formulier.",
  "choose.manual.action": "Gegevens handmatig invoeren",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Plak de zendinggegevens of upload een document, dan vullen wij het formulier voor u in.",
  "choose.quickfill.action": "Start snel invullen",

  "steps.route": "Route & order",
  "steps.shipment": "Zending",
  "steps.services": "Aanvullende diensten",
  "steps.contact": "Contact",
  "steps.review": "Controleren",

  "page.route": "Route en order",
  "page.routeSection": "Route",
  "page.shipment": "Zendinggegevens",
  "page.services": "Aanvullende diensten",
  "page.contact": "Contactgegevens",
  "page.contactSection": "Uw contactgegevens",
  "page.review": "Controleren",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Document wordt geanalyseerd",

  "route.hintPostcode": "Vul een postcode of plaats in voor laden en lossen.",
  "route.hintFullAddress": "Vul het volledige laad- en losadres in.",
  "route.unsupported": "Deze route wordt niet ondersteund. Gebruik het formulier voor {loadCountry} en {unloadCountry}.",
  "route.loading": "Laden",
  "route.unloading": "Lossen",
  "route.origin": "Herkomst",
  "route.destination": "Bestemming",
  "route.country": "Land",
  "route.selectCountry": "Selecteer land",
  "route.postcode": "Postcode",
  "route.postcodePlaceholder": "bijv. 3001 AA",
  "route.city": "Plaats",
  "route.cityPlaceholder": "Vul plaats in",
  "route.street": "Straatnaam",
  "route.streetPlaceholder": "Vul straat in",
  "route.house": "Huisnummer",
  "route.housePlaceholder": "bijv. 12",
  "route.pickupDate": "Gewenste ophaaldatum:",
  "route.unloadDate": "Gewenste losdatum:",
  "route.datePlaceholder": "dd/mm/jjjj",
  "date.clear": "Datum wissen",
  "date.closeCalendar": "Kalender sluiten",
  "date.openCalendar": "Kalender openen",
  "route.specificDateHint":
    "Voor goederen die op een specifieke datum beschikbaar zijn. Anders streven we naar de snelste optie.",
  "route.orderDetails": "Ordergegevens",

  "shipment.goods": "Omschrijving goederen",
  "shipment.goodsPlaceholder": "Wat wilt u vervoeren?",
  "shipment.weight": "Totaalgewicht",
  "shipment.qty": "Aantal",
  "shipment.type": "Type",
  "shipment.dims": "Afmetingen / LDM",
  "shipment.stackable": "Stapelbaar",
  "shipment.addRow": "Zendingregel toevoegen",
  "shipment.totalLines": "Totaal aantal regels: {count}",
  "shipment.selectDims": "Selecteer afmetingen",
  "shipment.dimsNa": "Afmetingen niet van toepassing",
  "shipment.sizeModeDims": "L × B × H",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Zendingregel {n} verwijderen",
  "shipment.lineLabel": "{text}, regel {n}",
  "shipment.quantity": "Aantal",
  "qty.decrease": "Aantal verlagen",
  "qty.increase": "Aantal verhogen",
  "shipment.lengthCm": "Lengte (cm)",
  "shipment.widthCm": "Breedte (cm)",
  "shipment.heightCm": "Hoogte (cm)",
  "shipment.dimensions": "Afmetingen",
  "shipment.size": "Maat",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Blok",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Halve pallet",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Afwijkend",
  "pallet.unspecified": "LDM",

  "services.aria": "Aanvullende diensten",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Temperatuur",
  "services.pill.tail": "Laadklep",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Tijdvenster",
  "services.pill.ref": "Referentie / opmerkingen",
  "services.pill.references": "Referenties",
  "services.pill.attachments": "Extra bijlagen",
  "services.adrClass": "ADR-klasse",
  "services.selectClass": "Selecteer klasse",
  "services.unNumber": "UN-nummer",
  "services.unPlaceholder": "bijv. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Laadklep bij laden",
  "services.tailUnload": "Laadklep bij lossen",
  "services.ftlCopy": "Volledige vrachtwagenlading aangevraagd.",
  "services.invoiceRef": "Factuurreferentie",
  "services.reference": "Referentie",
  "services.loadingRef": "Laadreferentie",
  "services.unloadingRef": "Losreferentie",
  "services.notes": "Opmerkingen",
  "services.notesPlaceholder": "bijv. speciale instructies",
  "services.deadline": "Gewenste leverdeadline:",
  "services.deliveryHint":
    "Voor goederen die op een specifieke datum geleverd moeten worden. Anders streven we naar de snelste optie.",
  "services.loadingTime": "Laadtijd",
  "services.unloadingTime": "Lostijd",
  "services.window": "Venster",
  "services.fixed": "Vast",
  "services.at": "om",
  "services.from": "van",
  "services.to": "tot",
  "services.timeTypeAria": "{title} type",
  "services.addFiles": "Bestanden toevoegen",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP of PDF. Maximaal {maxFiles} bestanden, {maxFileMb} MB per bestand, {maxTotalMb} MB in totaal.",
  "services.adrClass1": "1 Explosieven",
  "services.adrClass2": "2 Gassen",
  "services.adrClass3": "3 Brandbare vloeistoffen",
  "services.adrClass4": "4 Brandbare vaste stoffen",
  "services.adrClass5": "5 Oxiderende stoffen",
  "services.adrClass6": "6 Giftig / besmettelijk",
  "services.adrClass7": "7 Radioactief",
  "services.adrClass8": "8 Bijtend",
  "services.adrClass9": "9 Diverse gevaarlijke stoffen",
  "services.summary.adr": "Gevaarlijke stoffen (ADR)",
  "services.summary.temp": "Temperatuurgecontroleerd",
  "services.summary.time": "Tijdvensters",
  "services.summary.refNotes": "Referentie en opmerkingen",
  "services.summary.tail": "Laadklep",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Extra bijlagen",
  "services.tail.loadUnload": "Laden en lossen",
  "services.tail.loadOnly": "Alleen laden",
  "services.tail.unloadOnly": "Alleen lossen",
  "services.time.load": "Laden: {value}",
  "services.time.unload": "Lossen: {value}",
  "services.time.deadline": "Deadline: {value}",
  "services.time.fixedSuffix": "{time} (vast)",
  "services.time.windowRange": "{from} tot {until}",
  "services.adr.yes": "Ja",
  "services.adr.classUn": "Klasse {class}, UN {un}",
  "services.adr.classOnly": "Klasse {class}",
  "services.adr.unOnly": "UN {un}",
  "services.temp.range": "{min}°C tot {max}°C",
  "services.ref.invoice": "Factuur: {value}",
  "services.ref.loading": "Laden: {value}",
  "services.ref.unloading": "Lossen: {value}",

  "contact.name": "Naam",
  "contact.company": "Bedrijf",
  "contact.email": "E-mail",
  "contact.phone": "Telefoon",
  "contact.comment": "Aanvullende opmerking",
  "contact.privacyBefore":
    "Ik ga akkoord met de verwerking van mijn persoonsgegevens conform het ",
  "contact.privacyLink": "privacybeleid",
  "contact.privacyAfter": " van Neele-Vat.",

  "result.thankYou": "Bedankt! Uw aanvraag is ontvangen.",
  "result.teamWillContact":
    "Ons team neemt binnen 60 minuten contact met u op tijdens kantooruren.",
  "result.teamWillContactEmail":
    "Ons team neemt binnen 60 minuten tijdens kantooruren contact met u op via {email}.",
  "result.previewMode": "Voorvertoning — deze aanvraag is niet echt verstuurd.",
  "result.previewFiles": " Let op: bestanden kunnen in de voorvertoning niet worden meegestuurd.",
  "result.yourReference": "Uw referentie",
  "result.copy": "Kopiëren",
  "result.copied": "Gekopieerd",
  "result.nextTitle": "Wat gebeurt er nu",
  "result.next1": "Aanvraag ontvangen.",
  "result.next2": "Aanvraag wordt beoordeeld.",
  "result.next3": "Reactie binnen 60 minuten per e-mail.",
  "result.logged":
    "We hebben uw aanvraag vastgelegd. Hoort u niets, neem dan contact op via de gegevens hieronder.",
  "result.newQuote": "Nieuwe offerte starten",
  "result.sendFailed": "We konden uw aanvraag niet versturen",
  "result.preferDirect": "Liever direct contact?",
  "result.backToEdit": "Terug naar bewerken",
  "result.tryAgain": "Opnieuw proberen",
  "result.hideDetails": "Details verbergen",
  "result.viewSent": "Bekijk wat we hebben verstuurd",
  "result.error.rateLimited":
    "U heeft in korte tijd veel aanvragen gedaan. Wacht even en probeer het opnieuw.",
  "result.error.forbidden":
    "Deze aanvraag is geblokkeerd. Probeer het opnieuw of neem rechtstreeks contact met ons op.",
  "result.error.network":
    "We konden uw aanvraag nu niet versturen. Controleer uw verbinding en probeer het opnieuw.",
  "result.error.tooLarge":
    "Deze aanvraag is te groot om te versturen. Gebruik kleinere bijlagen of een kortere opmerking.",
  "result.error.unsupportedType": "Gebruik alleen JPEG, PNG, GIF, WebP of PDF.",
  "result.error.emailUnavailable":
    "We konden uw aanvraag met bijlagen niet e-mailen. Probeer het opnieuw of neem rechtstreeks contact op.",

  "qf.hint":
    "Plak een e-mail of zendinggegevens, of voeg een afbeelding of PDF toe. Dit vervangt eerder ingevulde gegevens.",
  "qf.placeholder":
    "bijv. 24 europallets van 3011 Rotterdam naar 20095 Hamburg, 12.000 kg, ophalen morgen…",
  "qf.ariaPaste": "Zendinggegevens om te analyseren",
  "qf.attach": "Afbeelding of PDF bijvoegen",
  "qf.disclaimer":
    "Wat u plakt of bijvoegt, gebruiken we alleen om deze aanvraag in te vullen. Het wordt verwerkt door onze documentanalyse en niet bewaard nadat het formulier is ingevuld.",
  "qf.fillForm": "Formulier invullen",
  "qf.working": "Bezig…",
  "qf.analyzing": "Uw gegevens worden geanalyseerd…",
  "qf.noFields": "Er konden geen velden worden herkend. Voeg meer details toe.",
  "qf.rateLimited": "U heeft te veel aanvragen gedaan. Wacht even en probeer het opnieuw.",
  "qf.blocked": "Deze aanvraag is geblokkeerd. Neem contact met ons op als dit onverwacht is.",
  "qf.extractUnavailable":
    "Documentanalyse is nu niet beschikbaar. Plak de zendinggegevens in plaats daarvan.",
  "qf.genericError": "Er ging iets mis. Controleer uw netwerk of probeer het opnieuw.",
  "qf.analyzeTitle": "Document wordt geanalyseerd...",
  "qf.analyzeSub": "Dit duurt meestal een paar seconden",
  "qf.analyzeStep1": "Documentstructuur lezen",
  "qf.analyzeStep2": "Basisgegevens extraheren",
  "qf.analyzeStep3": "Zendingregels herkennen",
  "qf.removeFile": "{name} verwijderen",

  "error.loadCountry": "Selecteer een laadland.",
  "error.loadPostal": "Vul de postcode van laden in.",
  "error.loadCity": "Vul de plaats van laden in.",
  "error.loadStreet": "Vul de straatnaam van laden in.",
  "error.loadHouseNumber": "Vul het huisnummer van laden in.",
  "error.unloadCountry": "Selecteer een losland.",
  "error.unloadPostal": "Vul de postcode van lossen in.",
  "error.unloadCity": "Vul de plaats van lossen in.",
  "error.unloadStreet": "Vul de straatnaam van lossen in.",
  "error.unloadHouseNumber": "Vul het huisnummer van lossen in.",
  "error.pickupDate": "Kies een ophaaldatum.",
  "error.unloadDate": "Kies een losdatum.",
  "error.invalidDate": "Voer een geldige datum in.",
  "error.totalWeight": "Vul het totaalgewicht in.",
  "error.goods": "Omschrijf de goederen.",
  "error.loadCityOrPostal": "Vul de postcode of plaats van laden in.",
  "error.unloadCityOrPostal": "Vul de postcode of plaats van lossen in.",
  "error.loadPostalInvalid": "Vul een herkende postcode van laden in.",
  "error.loadCityInvalid": "Vul een herkende plaats van laden in.",
  "error.unloadPostalInvalid": "Vul een herkende postcode van lossen in.",
  "error.unloadCityInvalid": "Vul een herkende plaats van lossen in.",
  "error.pickupPast": "De ophaaldatum mag niet in het verleden liggen.",
  "error.unloadPast": "De losdatum mag niet in het verleden liggen.",
  "error.unloadBeforePickup": "De losdatum mag niet eerder zijn dan de ophaaldatum.",
  "error.weightRange": "Vul een gewicht in tussen 1 en {max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Vul het 4-cijferige UN-nummer in.",
  "error.invoiceRef": "Vul de factuurreferentie in.",
  "error.loadingRef": "Vul de laadreferentie in.",
  "error.unloadingRef": "Vul de losreferentie in.",
  "error.tempMin": "Vul de minimumtemperatuur in.",
  "error.tempMax": "Vul de maximumtemperatuur in.",
  "error.tempOrder": "Max moet minstens min zijn.",
  "error.enterNumber": "Vul een getal in.",
  "error.deliveryPast": "De leverdeadline mag niet in het verleden liggen.",
  "error.deliveryBeforePickup": "De leverdeadline mag niet eerder zijn dan de ophaaldatum.",
  "error.tailSides": "Selecteer laden, lossen of beide.",
  "error.attachOne": "Voeg minstens één bestand toe.",
  "error.enterTime": "Vul een tijd in.",
  "error.enterStartTime": "Vul een starttijd in.",
  "error.enterEndTime": "Vul een eindtijd in.",
  "error.enterMinutes": "Vul de minuten in.",
  "error.completeTime": "Vul een volledige tijd in.",
  "error.enterEmail": "Vul uw e-mailadres in.",
  "error.validEmail": "Vul een geldig e-mailadres in.",
  "error.validPhone": "Vul een geldig telefoonnummer in.",
  "error.personalEmail": "Persoonlijke e-mailadressen worden niet geaccepteerd.",
  "error.enterName": "Vul uw naam in.",
  "error.enterCompany": "Vul uw bedrijf in.",
  "error.privacy": "Ga akkoord om door te gaan.",
  "error.quickFillEmpty":
    "Plak zendinggegevens of voeg een afbeelding of PDF toe om het formulier in te vullen.",
  "error.maxFiles": "U kunt maximaal {max} bestanden bijvoegen.",
  "error.maxFileMb": "Elk bestand mag maximaal {max} MB zijn.",
  "error.maxTotalMb": "Bijlagen mogen in totaal maximaal {max} MB zijn.",
  "error.filesSkippedType": "Sommige bestanden zijn overgeslagen. Gebruik JPEG, PNG, GIF, WebP of PDF.",
  "error.emptySkipped": "Lege bestanden zijn overgeslagen.",
  "error.fileEmpty": "Het geselecteerde bestand is leeg.",
  "error.filesEmptyOrType": "Sommige bestanden waren leeg of geen JPEG, PNG, GIF, WebP of PDF.",
  "error.attachType": "Voeg een JPEG, PNG, GIF, WebP of PDF toe.",
  "error.subjectLong": "Het onderwerp is te lang.",
  "error.emailTextLong": "De aanvraaggegevens zijn te lang.",
  "error.shortenSubject": "Kort deze waarde in zodat het e-mailonderwerp binnen {max} tekens blijft.",
  "error.shortenBody":
    "Kort de zendinggegevens of opmerking in zodat de e-mail binnen {max} tekens blijft.",

  "announce.choose": "Kies hoe u uw offerte wilt aanvragen",
  "announce.quickfill": "Snel invullen: plak gegevens of upload een document",
  "announce.route": "Stap 1 van 5: route en order",
  "announce.shipment": "Stap 2 van 5: zendinggegevens",
  "announce.services": "Stap 3 van 5: aanvullende diensten",
  "announce.contact": "Stap 4 van 5: contactgegevens",
  "announce.review": "Stap 5 van 5: controleer uw aanvraag",
  "announce.received": "Aanvraag ontvangen",
  "announce.sendFailed": "We konden uw aanvraag niet versturen",
  "announce.sendFailedAttempt": "We konden uw aanvraag niet versturen (poging {n})",
  "announce.completeFields": "Vul de gemarkeerde velden in voordat u doorgaat.",
  "announce.sending": "Uw aanvraag wordt verstuurd…",
};
